import { render, staticRenderFns } from "./ChatterIcon.vue?vue&type=template&id=795c0dce"
var script = {}


/* normalize component */
import normalizer from "!../../../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports